enum FileFieldEnum {
  MAX_VOLUME = 'Объем файла превышает 5MB',
  FILE_FORMAT = 'Неверный формат файла',
}

enum MaxFileEnum {
  MAX_FILE = 5242880,
}

interface IAddResult {}

interface MentorMapped {
  value: string;
  text: string;
}

type MentorsMapped = Array<MentorMapped>;

export { MentorsMapped, FileFieldEnum, MaxFileEnum, IAddResult };



// WEBPACK FOOTER //
// ./src/pages/profile/views/progress/forms/resultform/types.ts